export default __webpack_public_path__ + "6cf890b3f7392a728885d967eefb6f34.jpg";